export default __webpack_public_path__ + "static/media/Workflow.1a82dd80.svg";